const producers = {
  //生产商
  path: 'producers',
  component: () => import("@/views/member/producers/producers"),
  meta: {
    tabBar: false
  },
  children: [
    {
      path: 'returns-detailed',
      component: () => import("@/views/member/producers/returns-detailed"),
      meta: {
        tabBar: false
      },
    },
    {
      path: 'store-sj',
      component: () => import("@/views/member/producers/store-sj"),
      meta: {
        tabBar: false
      },
    }
  ]
};

export default producers;
